var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board"},[_c('table',_vm._l((_vm.board.rows),function(row,i){return _c('tr',{key:i},_vm._l((_vm.splitRow(row)),function(col,j){return _c('td',{key:j,style:({
					backgroundColor: col === '' ? '#ffffff' : _vm.color,
				})},[_vm._v("\n\t\t\t\t"+_vm._s(col)+"\n\t\t\t")])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }